import React from "react";

import "./animateSpeaker.css";

function SpeakerBand(props) {
  return (
    <svg
      width="278"
      height="278"
      viewBox="0 0 378 378"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M234 189C234 213.853 213.853 234 189 234C164.147 234 144 213.853 144 189C144 164.147 164.147 144 189 144C213.853 144 234 164.147 234 189ZM144.125 189C144.125 213.784 164.216 233.875 189 233.875C213.784 233.875 233.875 213.784 233.875 189C233.875 164.216 213.784 144.125 189 144.125C164.216 144.125 144.125 164.216 144.125 189Z"
        fill="#808080"
        fillOpacity="0.6"
      />
      <path
        d="M308 189C308 254.722 254.722 308 189 308C123.278 308 70 254.722 70 189C70 123.278 123.278 70 189 70C254.722 70 308 123.278 308 189ZM70.3302 189C70.3302 254.54 123.46 307.67 189 307.67C254.54 307.67 307.67 254.54 307.67 189C307.67 123.46 254.54 70.3302 189 70.3302C123.46 70.3302 70.3302 123.46 70.3302 189Z"
        fill="#808080"
        fillOpacity="0.5"
      />
      <path
        d="M204 189C204 197.284 197.284 204 189 204C180.716 204 174 197.284 174 189C174 180.716 180.716 174 189 174C197.284 174 204 180.716 204 189ZM174.134 189C174.134 197.21 180.79 203.866 189 203.866C197.21 203.866 203.866 197.21 203.866 189C203.866 180.79 197.21 174.134 189 174.134C180.79 174.134 174.134 180.79 174.134 189Z"
        fill="#969799"
      />
      <path
        d="M378 189C378 293.382 293.382 378 189 378C84.6182 378 0 293.382 0 189C0 84.6182 84.6182 0 189 0C293.382 0 378 84.6182 378 189ZM0.524368 189C0.524368 293.092 84.9078 377.476 189 377.476C293.092 377.476 377.476 293.092 377.476 189C377.476 84.9078 293.092 0.524368 189 0.524368C84.9078 0.524368 0.524368 84.9078 0.524368 189Z"
        fill="#969799"
      />
      <path
        d="M214.992 189.5C214.992 203.522 203.626 214.888 189.604 214.888C175.583 214.888 164.216 203.522 164.216 189.5C164.216 175.479 175.583 164.112 189.604 164.112C203.626 164.112 214.992 175.479 214.992 189.5ZM170.092 189.5C170.092 200.277 178.828 209.013 189.604 209.013C200.381 209.013 209.117 200.277 209.117 189.5C209.117 178.724 200.381 169.988 189.604 169.988C178.828 169.988 170.092 178.724 170.092 189.5Z"
        fill="#00617F"
      />
      <path
        className="recording-circle"
        d="M170.092 189.5C170.092 200.277 178.828 209.013 189.604 209.013C200.381 209.013 209.117 200.277 209.117 189.5C209.117 178.724 200.381 169.988 189.604 169.988C178.828 169.988 170.092 178.724 170.092 189.5Z"
        fill="#1C1F25"
      />
      <path
        d="M200.843 194.439C199.642 196.154 198.052 197.561 196.203 198.544C194.354 199.527 192.298 200.059 190.204 200.096C188.11 200.132 186.037 199.673 184.155 198.755C182.272 197.836 180.634 196.486 179.374 194.813L181.827 192.965C182.795 194.251 184.054 195.289 185.501 195.994C186.948 196.7 188.541 197.053 190.15 197.025C191.76 196.997 193.34 196.588 194.761 195.832C196.182 195.077 197.404 193.996 198.328 192.677L200.843 194.439Z"
        fill="#A1C1D9"
      />
      <path
        fill-rule="evenodd"
        clipRule="evenodd"
        d="M189.604 179.225C187.601 179.225 185.978 180.848 185.978 182.851V190.105C185.978 192.108 187.601 193.732 189.604 193.732C191.607 193.732 193.231 192.108 193.231 190.105V182.851C193.231 180.848 191.607 179.225 189.604 179.225ZM189.604 181.643C188.937 181.643 188.396 182.184 188.396 182.851V190.105C188.396 190.773 188.937 191.314 189.604 191.314C190.272 191.314 190.813 190.773 190.813 190.105V182.851C190.813 182.184 190.272 181.643 189.604 181.643Z"
        fill="#A1C1D9"
      />
    </svg>
  );
}

export default SpeakerBand;
